import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ScanReceiptPage from "./pages/ScanReceiptPage";
import ReceiptDetailPage from "./pages/ReceiptDetailPage";
import ReceiptsPage from "./pages/ReceiptsPage";
import CardsPage from "./pages/CardsPage";
import InsightsPage from "./pages/InsightsPage";
import ProfilePage from "./pages/Profilepage";
import VouchersPage from './pages/VouchersPage';
import VoucherDetailPage from './pages/VoucherDetailPage';
import CreateGroupPage from './pages/CreateGroupPage';
import GroupDetailPage from './pages/GroupDetailPage';
import MemberAccessPage from './pages/MemberAccessPage';
import AcceptInvitePage from './pages/AcceptInvitePage';
import CircleSummaryPage from './pages/CircleSummaryPage';


function AppRouter() {
  const location = useLocation();

  // CRITICAL: Check URL fragment for session_id synchronously during render
  // This prevents race conditions by processing new session_id FIRST before checking existing session_token
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scan"
        element={
          <ProtectedRoute>
            <ScanReceiptPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/receipts"
        element={
          <ProtectedRoute>
            <ReceiptsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/receipts/:id"
        element={
          <ProtectedRoute>
            <ReceiptDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cards"
        element={
          <ProtectedRoute>
            <CardsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/insights"
        element={
          <ProtectedRoute>
            <InsightsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route 
        path="/vouchers" 
          element={
            <ProtectedRoute>
               <VouchersPage />
            </ProtectedRoute>
          } 
      />
      <Route 
        path="/vouchers/:id" 
          element={
            <ProtectedRoute>
               <VoucherDetailPage />
            </ProtectedRoute>
          } 
      />
      {/* Group routes — static paths before :groupId */}
      <Route
        path="/groups/create"
        element={
          <ProtectedRoute>
            <CreateGroupPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/groups/invite/:token"
        element={<AcceptInvitePage />}
      />
      <Route
        path="/groups/:groupId"
        element={
          <ProtectedRoute>
            <GroupDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/groups/:groupId/summary"
        element={
          <ProtectedRoute>
            <CircleSummaryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/groups/:groupId/members/:memberId"
        element={
          <ProtectedRoute>
            <MemberAccessPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <Navigate to="/" replace />
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;